// Polyfill console for IE9
window.console =
  window.console ||
  (function () {
    var c = {};
    // prettier-ignore
    c.log = c.warn = c.debug = c.info = c.error = c.time = c.dir = c.profile = c.clear = c.exception = c.trace = c.assert = function() {};
    return c;
  })();

// Polyfill btoa/atob for IE9
import { btoa, atob } from "Base64";
if (!window.btoa) {
  window.btoa = btoa;
}
if (!window.atob) {
  window.atob = atob;
}

// General polyfill
import "babel-polyfill";
require("babel-runtime/core-js/promise").default = require("bluebird");

import React from "react";
import ReactDom from "react-dom";
import AppRoot from "./app-root.jsx";
import MultipleTabsMessage from "./multiple-tabs-message.jsx";

// Moment timezone setup
import momentTimezone from "moment-timezone";
momentTimezone.tz.setDefault(TENANT.display_timezone);
// momentTimezone.locale(navigator.language || 'en-US');

// Moment date parsing setup
const centuryCutoff = (new Date().getFullYear() % 1000) + 5;
momentTimezone.parseTwoDigitYear = yearString => {
  return (
    parseInt(yearString) + (parseInt(yearString) > centuryCutoff ? 1900 : 2000)
  );
};

// App styling
import "./app.scss";

// Logging setup
import "./logger";

// Fix popover bugs
import "./popover-fix.js";

// Tracking
import { initializeTracking } from "./utils/tracking";
initializeTracking();

// Needed for React Developer Tools
window.React = React;

// Stop pointless "Warning: owner-based and parent-based contexts differ"
// warning from appearing in modals, see:
// https://github.com/rackt/react-modal/issues/37
import throttle from "lodash/throttle";
var warn = console.warn;
var warningFilterKey = function (warning) {
  return (
    warning.indexOf("Warning: owner-based and parent-based contexts differ") >=
    0
  );
};
var throttledWarn = throttle(function () {
  warn.call(
    console,
    "Throttled warning about React owner/parent based contexts, see https://github.com/facebook/react/issues/4081 for reasons"
  );
  warn.apply(console, arguments);
}, 60000);
console.warn = function () {
  if (
    arguments &&
    arguments.length > 0 &&
    typeof arguments[0] === "string" &&
    warningFilterKey(arguments[0])
  ) {
    throttledWarn.apply(throttledWarn, arguments);
  } else {
    warn.apply(console, arguments);
  }
};

const inIframe = window.self !== window.top;

if (TENANT.enable_frontend_single_tab_only) {
  const bc = new BroadcastChannel("application_open");
  const bca = new BroadcastChannel("application_already_open");

  const appOpenedReceiver = event => {
    if (!inIframe && event.data === "Application Opened") {
      bca.postMessage("Application Already Open");
    }
  };

  bc.addEventListener("message", appOpenedReceiver);

  const appAlreadyOpenedReceiver = event => {
    if (!inIframe && event.data === "Application Already Open") {
      console.log("Shutting Down Application");
      bc.removeEventListener("message", appOpenedReceiver);
      ReactDom.render(<MultipleTabsMessage />, document.getElementById("app"));
    }
  };

  bca.addEventListener("message", appAlreadyOpenedReceiver);

  if (!inIframe) {
    bc.postMessage("Application Opened");
  }
}

ReactDom.render(<AppRoot />, document.getElementById("app"));

// Hide loader
if (document.getElementById("loader-custom")) {
  setTimeout(function () {
    document.getElementById("loader-custom").style.display = "none";
  }, 2000);
} else {
  document.getElementById("loader").style.display = "none";
}



// WEBPACK FOOTER //
// ./src/app/app.jsx